<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card
      title="Vamos a Verificar tu Identidad!"
      style="color:#ff5955 !important;"
      class="mb-2 margin-top text-center"
      v-show="this.showWelcomePanel"
    >
      <b-card-text
        class="margin-top text-center"
        style="color:#ff5955;"
      ><label v-html="this.ViewModel.WelcomeMsg"></label>
      </b-card-text>

      <b-button
        v-on:click="ComenzarAction"
        class="btn btn-success"
        v-show="this.ViewModel.ShowStartButton"
      >{{getStartButtonText}}</b-button>

      <b-button
        v-on:click="CerrarSesion"
        class="btn btn-danger"
        v-show="this.showAcceptButton"
      >Volver</b-button>

    </b-card>

    <b-card
      style="margin: 20px"
      v-show="!this.showWelcomePanel && !this.showResult && !this.showResultPending && !this.showNotAFIPConstancy"
    >
      <b-card-header header-tag="header" class="p-1" role="tab">Verificación de Identidad</b-card-header>
      <b-card-body>
        <!-- Control de Steps -->
        <form-wizard
          ref="wizard"
          title
          subtitle
          nextButtonText="Continuar"
          backButtonText="Volver"
          finishButtonText="Finalizar"
          @on-change="onChangeTab"
          @on-complete="OnFinish"
        >
          <!-- Contenido de STEP -->
          <tab-content
            v-for="item in this.ViewModel.PendingRequirementItems"
            :key="item.MissingRequirementItemEntityID"
            :index="item.Order"
            :before-change="validateForm"
          >
            <div id="itemcontainer" class="text-center">
              <div class="row">
                <div class="col-md-12">
                  <AddressComponent
                    v-if="item.RequirementType==formTypeAddres"
                    :Title="item.Text"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                  ></AddressComponent>
                  <TextComponent
                    v-if="item.RequirementType == formTypeText && item.MissingRequirementItemEntityID != formTypeCBU"
                    :Title="item.Text"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                  ></TextComponent>
                  <DocumentComponent
                    v-if="item.RequirementType == formTypeDNI"
                    :Title="item.Text"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                  ></DocumentComponent>
                  <ImageAttachmentComponent
                    v-if="item.RequirementType == formTypeIMG"
                    :Title="item.Text"
                    :Image="item.RequirementImageVUE"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                  ></ImageAttachmentComponent>
                  <AttachmentComponent
                    v-if="item.RequirementType == formTypeAdjunto"
                    :Title="item.Text"
                    :Image="item.RequirementImageVUE"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                  ></AttachmentComponent>
                  <ImageCodeAttachmentComponent
                    v-if="item.RequirementType == formTypeImageCode"
                    :Title="item.Text"
                    :Image="item.RequirementImageVUE"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                    :Code="item.ImageCode"
                  ></ImageCodeAttachmentComponent>
                  <CBUComponent
                    v-if="item.RequirementType == formTypeCBU"
                    :Title="item.Text"
                    :MaxLength="22"
                    @saveValue="saveValue"
                    @setErrors="setErrors"
                    :MissingItemEntityID="item.MissingRequirementItemEntityID"
                  ></CBUComponent>
                </div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </b-card-body>
    </b-card>

    <b-card class="mb-2 margin-top text-center" v-show="this.showResult">
      <b-card-text class="margin-top text-center" style="color:#ff5955;"></b-card-text>

      <b-alert variant="success" show>{{successMsg}}</b-alert>
      <base-button style="background:#ff5955;" type="danger" size="md" v-show="this.showAcceptButton &&  this.showResult" @click="onClickAccept()"><span>Aceptar</span></base-button>
    </b-card>

    <b-card class="mb-2 margin-top text-center" v-show="this.showResultPending">
      <b-card-text class="margin-top text-center" style="color:#ff5955;"></b-card-text>

      <b-alert style="background:#ff5955;" variant="warning" show>
        <p>{{successMsg}}</p>
        <p style="font-size:30px;">Solicitud Nro {{RequestID}}</p>
      </b-alert>
      <base-button style="background:#ff5955;" type="danger" size="md" v-show="this.showAcceptButton &&  this.showResultPending" @click="onClickAccept()"><span>Aceptar</span></base-button>
    </b-card> 

    <b-card class="mb-2 margin-top text-center" v-show="this.showNotAFIPConstancy">
      <div class="text-center">
            <img src="img/ob_reject.png" class="img-fluid" />
      </div>
      <b-card-text class="margin-top text-center" style="color:#ff5955;">{{AfipMsg}}</b-card-text>      
      <base-button style="background:#ff5955;" type="danger" size="md" v-show="this.showAcceptButton &&  this.showNotAFIPConstancy" @click="onClickAccept()"><span>Aceptar</span></base-button>
      <base-button style="background:#fff;" type="outline-danger" size="md" class="btnContactHelp" v-show="this.showNotAFIPConstancy" @click="onClickContact()"><span>Contactar con soporte</span></base-button>
    </b-card>
    <contact-help-desk
      ref="contact-help-desk"
      titleModal="Validación de identidad"
    />
  </div>
</template>

<style>
h4 {
  color: #ff5955 !important;
}

.upload-caption h2 {
  color: #ff5955 !important;
}

input[type="file"] {
  display: none;
}
.responsiveImage {
  max-width: 40%;
  width: auto;
  height: auto;
}
.btnContactHelp {
    border-color:#ff5855; 
    background-color:#fff;
    background: #fff;    
    color: #ff5855 !important;
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>

<script>
import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);
import store from "@/store";
import Vue from "vue";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import notificationHelpers from "@/helpers/notificationHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";
import confirmHelper from "@/helpers/confirmHelpers";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import AddressComponent from "@/components/FormsRequirementTypes/AddressComponent";
import AttachmentComponent from "@/components/FormsRequirementTypes/AttachmentComponent";
import DocumentComponent from "@/components/FormsRequirementTypes/DocumentComponent";
import ImageAttachmentComponent from "@/components/FormsRequirementTypes/ImageAttachmentComponent";
import ImageCodeAttachmentComponent from "@/components/FormsRequirementTypes/ImageCodeAttachmentComponent";
import TextComponent from "@/components/FormsRequirementTypes/TextComponent";
import ContactHelpDesk from "@/views/ContactHelpDesk";
import CBUComponent from "@/components/FormsRequirementTypes/CBUComponent";

//AttachmentComponent,DocumentComponent,ImageAttachmentComponent,TextComponent

export default {
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    AddressComponent,
    TextComponent,
    DocumentComponent,
    ImageAttachmentComponent,
    AttachmentComponent,
    ImageCodeAttachmentComponent,
    "contact-help-desk": ContactHelpDesk,
    CBUComponent
  },
  props:{
    showAcceptButton: {
        type: Boolean,
        default: true,
        description: "Parametro que indica si se muestra el boton aceptar con logout"
      },
  },
  data() {
    return {
      ViewModel: [],

      formTypeAddres: this.$store.getters.IDTipoRequisitoDireccion, //
      formTypeAdjunto: this.$store.getters.IDTipoRequisitoAdjunto,
      formTypeIMG: this.$store.getters.IDTipoRequisitoIMG,
      formTypeText: this.$store.getters.IDTipoRequisitoTXT,
      formTypeDNI: this.$store.getters.IDTipoRequisitoEscaneoDNI,
      formTypeImageCode: this.$store.getters.IDTipoRequisitoIMGCod,
      formTypeCBU: this.$store.getters.IDTipoRequisitoCBU,

      showWelcomePanel: true,

      currentItem: null,
      finish_msg:
        "¡Listo! Ya recibimos tu solicitud. Vamos a verificar los datos ingresados, y te avisaremos el resultado. Tu solicitud es la #{0}",
      showResult: false,
      successMsg: "",
      AfipMsg: "",
      showResultPending: false,
      RequestID: 0,
      model: {},
      JSONValues: [],
      Errors: [],
      VisitedTabs: [],
      showNotAFIPConstancy: false,
      helpDeskInformation: {
        Message: "",
        Show: false,
        ShowInfo: false,
        WhatsappUrl: "",
        PhoneNumber: "",
        EmailAddress: "",
        EmailSubject: "",
        MessageBody: "",
        ShowUnlockMail: false,
        Name: "",
        ShowContactarSoporte: false,
      },
    };
  },

  computed: {
    getStartButtonText() {
      if (this.ViewModel.HasCancelledRequest) return "Solicitar nuevamente";
      else return "Comenzar!";
    }
  },
  // Metodos
  methods: {
    setErrors(errors) {
      let context = this;
      context.Errors = errors;
    },
    validateForm() {
      let context = this;
      if (context.Errors.length == 0) return true;
      else {
        notificationHelpers.showError("Alerta!", context.Errors[0], context);
        return false;
      }
    },
    // Al iniciar la pantalla
    GetOnInit(context) {
      var params = {
        AccountID: store.getters.accountID,
        ValidateNextLevel: true
      };
      axiosHelpers.axiosGet(
        "IdentityValidation/GetPendingToValidate",
        params,
        context,
        function(data) {
          context.ViewModel = data.ResponseVM;
          context.ViewModel.WelcomeMsg=context.ViewModel.WelcomeMsg.replaceAll("{SaltoLinea}", "<br>")
          if (context.ViewModel.HasNotAFIPConstancy){
            context.showNotAFIPConstancy = true;
            context.showWelcomePanel = false;
            context.AfipMsg = context.$store.getters.MsgNotAfipConstancy;
          }
          else if (context.ViewModel.PendingRequirementItems.length == 0) {
            if (context.ViewModel.AlreadyValidated) {
              context.showResult = true;
              context.successMsg = context.ViewModel.WelcomeMsg;
              context.showWelcomePanel = false;
              return;
            } else {
              context.showResultPending = true;
              context.successMsg = context.ViewModel.WelcomeMsg;
              context.showWelcomePanel = false;
              context.RequestID = context.ViewModel.RequestID;
            }
          }
        }
      );
    },
    // Al clickear boton Comenzar
    ComenzarAction() {
      this.showWelcomePanel = false;
      this.currentItem = this.ViewModel.PendingRequirementItems[0];
      this.Errors.push("Debe completar los datos del formulario");
      this.VisitedTabs.push(0);
    },

    CerrarSesion(){
      let context = this;
      axiosHelpers.axiosPost("Account/InitialLogout", {}, this, function(data) {
        if (data.ResponseVM != null) {
          context.$store.dispatch("logout").then(() => {
            context.$router.push("login");
          });
        }
      });
    },

    onChangeTab(prevtab, nexttab) {
      if (
        this.ViewModel != null &&
        this.ViewModel.PendingRequirementItems != null &&
        this.ViewModel.PendingRequirementItems.length > 0
      ) {
        this.currentItem = this.ViewModel.PendingRequirementItems[nexttab];

        var oldElement = this.JSONValues.find(
          d =>
            d.MissingItemEntityID ===
            this.currentItem.MissingRequirementItemEntityID
        );

        if (oldElement == undefined) {
          this.Errors.push("Debe completar los datos del formulario");
          this.VisitedTabs.push(nexttab);
        } else {
          this.Errors = [];
        }
      }
    },
    saveValue(value) {
      var oldElement = this.JSONValues.find(
        d => d.MissingItemEntityID === value.MissingItemEntityID
      );
      if (oldElement != undefined) {
        this.JSONValues.pop(oldElement);
      }

      this.JSONValues.push(value);
    },
    // -- Cuando finaliza de cargas las fotos
    OnFinish() {
      let context = this;
      confirmHelper.showConfirm(
        "Ya casi estamos listos! Si completaste correctamente los requerimientos, confirmalo asi recibimos tu solicitud de validación de identidad!",
        this,
        function() {
          context.Save(context);
        }
      );
    },
    // Envia a guardar los datos
    Save(context) {
      var Request = { RequestID: this.ViewModel.RequestID, Items: [] };

      this.JSONValues.forEach(element => {
        let item = {
          MissingItemEntityID: element.MissingItemEntityID,
          JSON: element.JSON
        };
        Request.Items.push(item);
      });
      axiosHelpers.axiosPost(
        "IdentityValidation/Save",
        Request,
        context,

        function(data) {
          context.showResult = true;
          context.successMsg = context.finish_msg.replace(
            "{0}",
            context.ViewModel.RequestID
          );
        }
      );
    },
    onClickAccept() {
      let context = this;
      axiosHelpers.axiosPost("Account/InitialLogout", {}, context, function(data) {
        if (data.ResponseVM != null) {
          context.$store.dispatch("logout").then(() => {
            context.$router.push("login");
          });
        }
      });
    },
    onClickContact(){
        let context = this;
        context.helpDeskInformation.Show = true;
        context.helpDeskInformation.ShowContactarSoporte = true;
        context.helpDeskInformation.Message = "Su CUIT no posee una constancia activa";
        context.helpDeskInformation.EmailAddress =
          context.$store.getters.EmailAddress;
        context.helpDeskInformation.EmailSubject =
          context.$store.getters.EmailSubject;
        context.helpDeskInformation.MessageBody =
          context.$store.getters.MessageBody;
        context.helpDeskInformation.UrlWhatsapp =
          context.$store.getters.UrlWhatsapp;
        context.helpDeskInformation.PhoneNumber =
          context.$store.getters.PhoneNumber;
        context.$refs["contact-help-desk"].setHelpDeskInformation(
          context.helpDeskInformation
        );
    }
  },

  created: function() {
    let context = this;
    this.GetOnInit(context);
  },

  mounted: function() {}
};
</script>